<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 5.2h9.5M7 10h9.5M7 14.8h9.5M3.7 5.2h.01M3.7 10h.01M3.7 14.8h.01"/></svg>
</template>
